import React, { useContext, useState } from 'react'
import Login from '../components/Login'
import { Link } from 'react-router-dom'
import { UserContext } from '../App'

const LoginView = () => {

    const user = useContext(UserContext)
    const [login, setLogin] = useState(true)
    return (
        <div className='container h-screen'>
            <Link to="/" ><div className='back-arrow border ms-6 p-5 flex justify-center items-center bg-indigo-600 text-sky-400 dark:bg-indigo-950 dark:border-slate-800 hover:bg-indigo-500'>
                <i className="fa-solid fa-arrow-left"></i>
            </div></Link>
            <Login user={user} />
        </div>
    )
}

export default LoginView